// create flux standard actions (FSA)
import {createAction} from 'redux-actions'
// payload and action creator
import {COPY2PAYLOAD} from 'uix/actions'

export const loadWidgetData = createAction('LOAD_WIDGET_DATA', otids => ({otids}))
export const setWidgetData = createAction('SET_WIDGET_DATA', otid2data => ({otid2data}))
